module.exports = {
    missingRequired: 'You must enter a value for required fields!',
    missingUsername: 'Please enter your username.',
    missingPassword: 'Please enter your password.',
    passwordMismatch: 'Passwords doens\'t match.',
};
